export const EXPEREMENTS_PROD = true;
export const EX_AUTH_DOMAIN = 'texauth.zerofactor.ru';
